module.exports = __webpack_public_path__ + "fonts/opensans-lightitalic.5687bc0c.ttf";